var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overrides"},[_c('element-overrides',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected),expression:"selected"}]}),_c('all-overrides',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selected),expression:"!selected"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }